import moment from "moment";

// 分页参数
export const pageSizes = [10, 20, 30, 50, 100, 200];

// type为字符串类型，有两种选择，"s"代表开始,"e"代表结束，dates为数字类型，不传或0代表本周，-1代表上周
function getMonth(type, monthss) {
  const d = new Date();
  let months = monthss;
  let year = d.getFullYear();
  let month = d.getMonth() + 1;
  if (Math.abs(months) > 12) {
    months %= 12;
  }
  if (months !== 0) {
    if (month + months > 12) {
      year += 1;
      month = (month + months) % 12;
    } else if (month + months < 1) {
      year -= 1;
      month = 12 + month + months;
    } else {
      month += months;
    }
  }
  month = month < 10 ? `0${month}` : month;
  const firstday = `${year}-${month}-01`;
  let lastday = "";
  if (
    month === "01" ||
    month === "03" ||
    month === "05" ||
    month === "07" ||
    month === "08" ||
    month === "10" ||
    month === "12"
  ) {
    lastday = `${year}-${month}-31`;
  } else if (month === "02") {
    if (
      (year % 4 === 0 && year % 100 !== 0) ||
      (year % 100 === 0 && year % 400 === 0)
    ) {
      lastday = `${year}-${month}-29`;
    } else {
      lastday = `${year}-${month}-28`;
    }
  } else {
    lastday = `${year}-${month}-30`;
  }
  let day = "";
  if (type === "s") {
    day = firstday;
  } else {
    day = lastday;
  }
  return day;
}

// dateTime 控件参数
export const pickerOptions = {
  shortcuts: [
    {
      text: "本月",
      onClick(picker) {
        const end = moment().format("YYYY-MM-DD");
        const start = getMonth("s", 0);
        picker.$emit("pick", [`${start} 00:00:00`, `${end} 23:59:59`]);
      },
    },
    {
      text: "上月",
      onClick(picker) {
        const end = getMonth("e", -1);
        const start = getMonth("s", -1);
        picker.$emit("pick", [`${start} 00:00:00`, `${end} 23:59:59`]);
      },
    },
    {
      text: "最近一周",
      onClick(picker) {
        const end = moment().format("YYYY-MM-DD");
        const start = moment().subtract(7, "days").format("YYYY-MM-DD");
        picker.$emit("pick", [`${start} 00:00:00`, `${end} 23:59:59`]);
      },
    },
    {
      text: "最近一个月",
      onClick(picker) {
        const end = moment().format("YYYY-MM-DD");
        const start = moment().subtract(30, "days").format("YYYY-MM-DD");
        picker.$emit("pick", [`${start} 00:00:00`, `${end} 23:59:59`]);
      },
    },
    {
      text: "最近三个月",
      onClick(picker) {
        const end = moment().format("YYYY-MM-DD");
        const start = moment().subtract(90, "days").format("YYYY-MM-DD");
        picker.$emit("pick", [`${start} 00:00:00`, `${end} 23:59:59`]);
      },
    },
  ],
};
// dateTime 控件参数
export const pickerOptionsToday = {
  disabledDate(time) {
    return time.getTime() > Date.now();
  },
  shortcuts: [
    {
      text: "当日",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "本月",
      onClick(picker) {
        const start = getMonth("s", 0);
        const end = moment().format("YYYY-MM-DD");
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "上月",
      onClick(picker) {
        const end = getMonth("e", -1);
        const start = getMonth("s", -1);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "最近一周",
      onClick(picker) {
        const end = moment().format("YYYY-MM-DD");
        const start = moment().subtract(7, "days").format("YYYY-MM-DD");
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "最近一个月",
      onClick(picker) {
        const end = moment().format("YYYY-MM-DD");
        const start = moment().subtract(30, "days").format("YYYY-MM-DD");
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "最近三个月",
      onClick(picker) {
        const end = moment().format("YYYY-MM-DD");
        const start = moment().subtract(90, "days").format("YYYY-MM-DD");
        picker.$emit("pick", [start, end]);
      },
    },
  ],
};
export const drugTypes = [
  {
    label: "全部",
    value: -1,
  },
  {
    label: "西药",
    value: 1,
  },
  {
    label: "中药饮片",
    value: 2,
  },
  {
    label: "中药颗粒",
    value: 16,
  },
  {
    label: "中成药",
    value: 3,
  },
  {
    label: "保健品",
    value: 4,
  },
  {
    label: "医疗器械",
    value: 5,
  },
  {
    label: "其他",
    value: 8,
  },
  {
    label: "贴敷中药",
    value: 9,
  },
];
export const drugType = [
  {
    label: "全部",
    value: -1,
  },
  {
    label: "西药",
    value: 1,
  },
  {
    label: "中药饮片",
    value: 2,
  },
  {
    label: "中成药",
    value: 3,
  },
  {
    label: "医疗器械",
    value: 5,
  },
  {
    label: "其他(药品)",
    value: 8,
  },
  {
    label: "贴敷中药",
    value: 9,
  },
  {
    label: "检查治疗项",
    value: 10,
  },
  {
    label: "附加费用",
    value: 11,
  },
  {
    label: "颗粒",
    value: 16,
  },
  {
    label: "加工服务",
    value: 17,
  },
  {
    label: "检验",
    value: 21,
  },
  {
    label: "检查",
    value: 22,
  },
  {
    label: "治疗理疗",
    value: 23,
  },
  {
    label: "其他费用",
    value: 24,
  },
  {
    label: "套餐",
    value: 25,
  },
];

export const drugTypeSome = [
  {
    label: "西药",
    value: 1,
  },
  {
    label: "中药饮片",
    value: 2,
  },
  {
    label: "中药颗粒",
    value: 16,
  },
  {
    label: "中成药",
    value: 3,
  },
  {
    label: "保健品",
    value: 4,
  },
  {
    label: "医疗器械",
    value: 5,
  },
  {
    label: "其他",
    value: 8,
  },
  {
    label: "贴敷中药",
    value: 9,
  },
];

export const reasonIdList = [
  {
    value: -1,
    label: "全部",
  },
  {
    value: 1,
    label: "自定义",
  },
  {
    value: 2,
    label: "采购入库",
  },
  {
    value: 3,
    label: "采购退货",
  },
  {
    value: 4,
    label: "售药",
  },
  {
    value: 5,
    label: "退药",
  },
  {
    value: 6,
    label: "盘点入库",
  },
  {
    value: 7,
    label: "盘点出库",
  },
  {
    value: 9,
    label: "调拨入库",
  },
  {
    value: 10,
    label: "其他入库",
  },
  {
    value: 11,
    label: "调拨出库",
  },
  {
    value: 12,
    label: "报损出库",
  },
  {
    value: 13,
    label: "其他出库",
  },
];

// 在当前页面停留时间再跳转页面
export const PAGE_STAY_COUNT = 800;

export const GENDER_OPTOINS = [
  {
    value: -1,
    label: "未知",
  },
  {
    value: 0,
    label: "女",
  },
  {
    value: 1,
    label: "男",
  },
];

export const ORDER_TYPE_ORTIONS = [
  {
    value: 1,
    label: "门诊病历",
  },
  {
    value: 2,
    label: "直接售药",
  },
  {
    value: 3,
    label: "挂号",
  },
];

export const PAY_TYPE_OPTIONS = [
  {
    label: "现金",
    value: "cashAmt",
  },
  {
    label: "支付宝",
    value: "alipayAmt",
  },
  {
    label: "微信",
    value: "wechatAmt",
  },
  {
    label: "银行卡",
    value: "posAmt",
  },
  {
    label: "余额",
    value: "remainingAmt",
  },
  {
    label: "医保",
    value: "medicalInsurance",
  },
  {
    label: "商保",
    value: "commercialInsurance",
  },
  {
    label: "其他",
    value: "otherAmt",
  },
];

export const PAY_TYPE_OPTIONSS = [
  {
    label: "全部",
    value: 0,
  },
  {
    label: "现金",
    value: 1,
  },
  {
    label: "支付宝",
    value: 2,
  },
  {
    label: "微信",
    value: 3,
  },
  {
    label: "银行卡",
    value: 4,
  },
  {
    label: "余额",
    value: 10,
  },
  {
    label: "医保(基金支付)",
    value: 7,
  },
  {
    label: "医保(个帐)",
    value: 13,
  },
  {
    label: "医保(共济)",
    value: 14,
  },
  {
    label: "商保",
    value: 8,
  },
  {
    label: "其他",
    value: 5,
  },
  {
    label: "微信小程序",
    value: 11,
  },
  {
    label: "微信当面付",
    value: 12,
  },
];

export const PAY_TYPE_OPTIONSSS = [
  {
    label: "全部",
    value: 0,
  },
  {
    label: "现金",
    value: 1,
  },
  {
    label: "支付宝",
    value: 2,
  },
  {
    label: "微信",
    value: 3,
  },
  {
    label: "银行卡",
    value: 4,
  },
  {
    label: "余额",
    value: 10,
  },
  {
    label: "欠费支付",
    value: 6,
  },
  {
    label: "医保(基金支付)",
    value: 7,
  },
  {
    label: "医保(个帐)",
    value: 13,
  },
  {
    label: "医保(共济)",
    value: 14,
  },
  {
    label: "商保",
    value: 8,
  },
  {
    label: "其他",
    value: 5,
  },
  {
    label: "微信小程序",
    value: 12,
  },
  {
    label: "微信当面付",
    value: 13,
  },
];

export const ORDER_TYPE_OPTION = [
  {
    label: "门诊病历",
    value: 1,
  },
  {
    label: "直接售药",
    value: 2,
  },
  {
    label: "挂号",
    value: 3,
  },
];

export const STAT_TYPES = [
  {
    value: 0,
    label: "全部",
  },
  {
    value: 1,
    label: "门诊病历",
  },
  {
    value: 2,
    label: "直接售药",
  },
  {
    value: 3,
    label: "挂号",
  },
];

export const optionTime = [
  {
    // 优惠券有效期
    value: 7,
    label: "一周",
  },
  {
    value: 30,
    label: "一个月",
  },
  {
    value: 90,
    label: "三个月",
  },
  {
    value: 180,
    label: "半年",
  },
];

export const ageSections = [
  {
    // 年龄段
    value: null,
    label: "全部",
  },
  {
    value: 1,
    label: "14岁以下",
  },
  {
    value: 2,
    label: "14岁~28岁",
  },
  {
    value: 3,
    label: "28岁~40岁",
  },
  {
    value: 4,
    label: "40岁~55岁",
  },
  {
    value: 5,
    label: "55岁以上",
  },
];
export const hilistLmtpricTypeList = [
  { key: 0, value: "不区分医院级别" },
  { key: 1, value: "一级及以下" },
  { key: 2, value: "二级" },
  { key: 3, value: "三级" },
];

// 医保状态
// 0 未开通 1开通 2 通讯成功 3 通讯失败
export const medicalInsuranceStatus = [
  { value: "0", label: "未开通" },
  { value: "1", label: "开通" },
  { value: "2", label: "通讯成功" },
  { value: "3", label: "通讯失败" },
];
